import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-0.5" }
const _hoisted_2 = { class: "text-sm text-dark-800" }


import AppMissingData from '@/components/Base/AppMissingData.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemDetailsOverviewProperty',
  props: {
  label: {
    type: String,
    required: true,
  },
  value: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(props.label), 1),
    _createElementVNode("div", null, [
      (props.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(props.value), 1)
          ], 64))
        : (_openBlock(), _createBlock(AppMissingData, { key: 1 }))
    ])
  ]))
}
}

})